import { jsx as _jsx } from "react/jsx-runtime";
import { formatJalaliDate, formatJalaliDateTime, formatJalaliFull, formatJalaliLong, formatRelativeFa, formatTehranTime, } from '@bookora/shared';
import { Tooltip } from '../antd/overlays.js';
import { Numeric } from './bidi.js';
const RENDERERS = {
    short: (d) => formatJalaliDate(d),
    long: (d) => formatJalaliLong(d),
    full: (d) => formatJalaliFull(d),
    dateTime: (d) => formatJalaliDateTime(d),
    time: (d) => formatTehranTime(d),
};
function coerce(value) {
    if (value === null || value === undefined || value === '')
        return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
export function JalaliDate({ value, variant = 'short', withRelative = true, fallback = '—', className, }) {
    const date = coerce(value);
    if (!date)
        return _jsx("span", { className: className, children: fallback });
    const body = (_jsx(Numeric, { as: "time", dir: "auto", dateTime: date.toISOString(), className: className, children: RENDERERS[variant](date) }));
    if (!withRelative)
        return body;
    return _jsx(Tooltip, { title: `${formatJalaliDateTime(date)} — ${formatRelativeFa(date)}`, children: body });
}
/** «۱۲ دقیقه پیش», with the exact Jalali timestamp in a tooltip. */
export function RelativeTime({ value, fallback = '—', className }) {
    const date = coerce(value);
    if (!date)
        return _jsx("span", { className: className, children: fallback });
    return (_jsx(Tooltip, { title: formatJalaliDateTime(date), children: _jsx(Numeric, { as: "time", dir: "auto", tabular: false, dateTime: date.toISOString(), className: className, children: formatRelativeFa(date) }) }));
}
//# sourceMappingURL=jalali-date.js.map